import { DateTime } from 'luxon';

import { API_DATE_FORMAT, convertToDateString } from 'theSource/utils';
import { DetailedBenefit } from '../../../utils';
import {
  LabelValueListItem,
  PlanContentDetails,
  PlanContentDetailsDto,
} from '../types';

export const BENEFIT_CLASS_TYPES = {
  TIER: 'tier',
  CONTRIBUTION: 'contribution',
  VOLUME: 'volume',
  FOUR_O_ONE_K: '401k',
  SURVEY: 'survey',
  BENEFIT_HSA: 'hsa',
};

export const mapPlanContentDetails = (
  contentDetails: PlanContentDetailsDto[]
): PlanContentDetails[] =>
  contentDetails.map((item) => ({
    id: item.id,
    label: item.label,
    inNetwork: item.in_network,
    outOfNetwork: item.out_of_network,
    preferredNetwork: item.preferred_network,
  }));

export const mapCurrentBenefitDetails = (
  benefit: DetailedBenefit
): LabelValueListItem[] => {
  const details = [];
  details.push({
    label: benefit.isWaived ? 'declinedDate' : 'startDate',
    value: benefit.coverageStart
      ? convertToDateString(
          DateTime.fromFormat(benefit.coverageStart, API_DATE_FORMAT)
        )
      : undefined,
  });
  details.push({
    label: 'coverageLevel',
    value: benefit.coverageLevel,
  });
  if (benefit.benefitClass === BENEFIT_CLASS_TYPES.VOLUME) {
    details.push({
      label: benefit.volumeText ?? 'volume',
      value: benefit.volume,
      isNumber: true,
    });
  }
  if (benefit.benefitClass === BENEFIT_CLASS_TYPES.CONTRIBUTION) {
    if (benefit.premiumMethod === 'monthly_amount') {
      details.push({
        label: 'employeeMonthlyContribution',
        value: benefit.employeeFsaAmount,
        isNumber: true,
      });
      details.push({
        label: 'employerMonthlyContribution',
        value: benefit.employerFsaAmount,
        isNumber: true,
      });
    } else {
      details.push({
        label: 'employeeAnnualTarget',
        value: benefit.employeeFsaAmount,
        isNumber: true,
      });
      details.push({
        label: 'employerAnnualContribution',
        value: benefit.employerFsaAmount,
        isNumber: true,
      });
    }
  }

  details.push({
    label:
      benefit.benefitClass === BENEFIT_CLASS_TYPES.FOUR_O_ONE_K
        ? 'employerMatch'
        : 'employerContribution',
    value: benefit.employerContribution,
    isNumber: true,
  });

  return details.filter((item) => item.value && item.value !== '0.0');
};
